import React, { useEffect, useRef, useState } from 'react'
import { DateTime, Info } from 'luxon'
import { FiCalendar } from 'react-icons/fi'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { useOutsideClick } from '../../utils/hooks'
import uniqueId from 'lodash/uniqueId'
import capitalize from 'lodash/capitalize'
import Button from '../General/Button'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const Datepicker: React.FC<DatepickerProps> = ({
  label = '',
  placeholder = '',
  register,
  error,
  rules,
  name,
  defaultValue,
  size = 'default',
  onShowDate = () => {},
  calendarPosition = undefined,
  onChangeDate = () => {},
  topPosition = undefined
}) => {
  const today = DateTime.local().setLocale('es')
  const [month, setMonth] = useState<number>(
    (defaultValue && Number(defaultValue.split('/')[1])) || today.month
  )
  const [year, setYear] = useState<number>(
    (defaultValue && Number(defaultValue.split('/')[2])) || today.year
  )
  const [date, setDate] = useState<string>(
    defaultValue || today.toLocaleString()
  )
  const [showCalendar, setShowCalendar] = useState<boolean>(false)
  const [blanksDays, setBlanksDays] = useState<number[]>([])
  const [noOfDays, setNoOfDays] = useState<number[]>([])
  const { addAlert } = useSnackBars()

  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, () => {
    setShowCalendar(false)
    onShowDate(false)
  })
  const randomId = uniqueId('label-')

  useEffect(() => {
    if (onChangeDate) {
      onChangeDate(today.toFormat("dd/MM/yyyy"))
    }  
  }, [])

  useEffect(() => {
    console.log("Default", defaultValue)
    setMonth((defaultValue && Number(defaultValue.split('/')[1])) || today.month)
    setYear((defaultValue && Number(defaultValue.split('/')[2])) || today.year)
    setDate(defaultValue || today.toLocaleString())

  }, [defaultValue])

  const monthNames = Info.months('long', { locale: 'es' })
  const days = Info.weekdays('short', { locale: 'es' })

  const isToday = (day: number) => {
    const _date = defaultValue
      ? DateTime.fromObject({
          year: Number(defaultValue.split('/')[2]),
          month: Number(defaultValue.split('/')[1]),
          day,
          locale: 'es',
        })
      : DateTime.fromObject({ year, month, day, locale: 'es' })
    return today.toLocaleString() === _date.toLocaleString()
  }

  const getDateValue = (day: number) => {
    const selectedDate = DateTime.fromObject({ year, month, day, locale: 'es' })
    /** Comparación que se hace con la finalidad de que no dejar ingresar fechas menores a estas
     * Solicitud de daniel para no tener problemas con consultar las tasas del dolar.
     */
    let compareDate = DateTime.fromObject({year: 2022, month: 1, day: 1})
    if (selectedDate >= compareDate) {
      if (onChangeDate) {
        console.log("ver selected", selectedDate)
        onChangeDate(selectedDate.toFormat("dd/MM/yyyy"))
      }
      // console.log("locaele", selectedDate.toLocaleString())
      setDate(selectedDate.toLocaleString())
      setShowCalendar(false)
      onShowDate(false)
    } else {
      addAlert({
        message: 'La fecha no puede ser menor al 01/01/2022',
        status: 'error',
      })
    }
  }

  const getNDays = () => {
    const dayOfWeek = DateTime.fromObject({
      year,
      month,
      day: 1,
      locale: 'es',
    }).weekday
    const blankdaysArray: number[] = []
    for (let i = 1; i <= dayOfWeek; i++) {
      blankdaysArray.push(i)
    }
    const daysInMonth = DateTime.fromObject({
      year,
      month,
      locale: 'es',
    }).daysInMonth
    const daysArray: number[] = []
    for (let i = 1; i <= daysInMonth; i++) {
      daysArray.push(i)
    }
    setBlanksDays(blankdaysArray)
    setNoOfDays(daysArray)
  }

  const accum = (value: number) => {
    if (month === 1 && value <= -1) {
      setYear(year - 1)
      setMonth(12)
    } else if (month === 12 && value >= 1) {
      setYear(year + 1)
      setMonth(1)
    } else setMonth(month + value)
  }

  useEffect(() => {
    getNDays()
    //eslint-disable-next-line
  }, [month, year])

  return (
    <div
      ref={wrapperRef}
      onClick={() => {
        setShowCalendar(true)
        onShowDate(true)
      }}
      className="mt-1 cursor-pointer flex flex-col relative"
    >
      <label
        htmlFor={randomId}
        className="font-medium text-primary-900 text-xs dark:text-white"
      >
        {label}
      </label>
      <div className="flex flex-col-reverse w-full mb-2 relative">
        <input
          readOnly
          value={date}
          className={`dark:bg-gray-600 dark:border-gray-600 dark:text-white cursor-pointer transition overflow-ellipsis overflow-x-hidden whitespace-nowrap w-full 
        ${
          size === 'small'
            ? 'h-inputSmall'
            : size === 'large'
            ? 'h-inputLarge'
            : 'h-inputDefault'
        } ${error && 'border-danger focus:border-danger'}`}
          id={randomId}
          name={name}
          placeholder={placeholder}
          type="text"
          ref={register ? register(rules) : undefined}
        />
        <label
          htmlFor={name}
          className="absolute right-1 top-1/2 -mt-2 text-gray-500"
        >
          {<FiCalendar />}
        </label>
      </div>
      <div
      style={{marginLeft: calendarPosition && -calendarPosition, marginTop: topPosition}}
        className={`${
          // !showCalendar ? 'invisible' : 'visible'
          !showCalendar ? 'hidden' : ''
        } py-1 px-4 rounded scale shadow-md h-auto w-72 absolute bg-white dark:bg-gray-800 z-10 top-full border-gray-100 border-solid border-1 overflow-y-auto`}
      >
        <div className="flex justify-between items-center mb-2">
          <div>
            <span className="text-sm font-bold">
              {capitalize(monthNames[month - 1])}
            </span>
            <span className="ml-1 text-sm text-gray-500 dark:text-gray-200">
              {year}
            </span>
          </div>
          <div className="flex">
            <Button
              type="link"
              classes="transition ease-in-out duration-100 p-1 rounded-full"
              onClick={() => accum(-1)}
            >
              <IoIosArrowBack />
            </Button>
            <Button
              type="link"
              classes="transition ease-in-out duration-100 p-1 rounded-full"
              onClick={() => accum(1)}
            >
              <IoIosArrowForward />
            </Button>
          </div>
        </div>
        <div className="flex flex-wrap mb-3 -mx-1">
          {days.map((d, i) => (
            <div style={{ width: '14.26%' }} key={i} className="px-1">
              <div className="font-semibold text-center text-xs">
                {capitalize(d)}
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap -mx-1">
          {blanksDays.map((d, i) => (
            <div
              style={{ width: '14.26%' }}
              key={i}
              className="text-center border p-1 border-transparent text-sm"
            >
              {' '}
            </div>
          ))}
          {noOfDays.map((d, i) => (
            <div
              style={{ width: '14.26%' }}
              onClick={(e) => {
                e.stopPropagation()
                getDateValue(d)
              }}
              className="px-1 mb-1"
              key={i}
            >
              <div
                className={`cursor-pointer text-center text-sm rounded-full leading-loose transition ease-in-out duration-100 
            ${
              isToday(d)
                ? 'bg-primary-light dark:bg-primary-dark dark:bg-opacity-60 text-white'
                : DateTime.fromObject({
                    year,
                    month,
                    day: d,
                    locale: 'es',
                  }).toLocaleString() === date
                ? 'bg-primary dark:bg-primary-dark text-white'
                : 'text-gray-500 dark:text-gray-300  hover:bg-primary-lighter dark:hover:bg-primary-dark dark:hover:bg-opacity-30'
            }`}
              >
                {d}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Datepicker

interface DatepickerProps {
  label?: string
  defaultValue?: any
  placeholder?: string
  [key: string]: any
  onShowDate?: (param: boolean) => void
  calendarPosition?: number
  onChangeDate? : (date: string) => void
  topPosition?: number
}
